import {
  TileLink,
  TileImage,
  TileDescription,
  TileWrapper,
  TileMeta,
  MetaWrapper,
  MetaData,
  TileImageWrapper,
  TileIcon,
  TileIconImg,
  PremiumIcon,
  TileCTA,
} from "./Tile.styled";

import moment from "moment";
import gameIcon from "../../assets/game_icon.png";
import quizIcon from "../../assets/quiz_icon.png";

import wordfinderIcon from "../../assets/wordfinder.png";
import crosswordIcon from "../../assets/crosswords.png";
import sudokuIcon from "../../assets/sudoku.png";
import slideIcon from "../../assets/slidepuzzle.png";

// moment.locale("he");

function Tile({ game, onGameClick, isFeatured, gameIndex, isAside }) {
  const {
    category,
    description,
    name,
    gameType,
    id,
    poster: src,
    posterFeatured: srcFeatured,
    publishedAt,
    subCategory,
    isPremium,
  } = game;

  const isPuzzle = category === "puzzle";

  const days = {
    0: "היום",
    1: "אתמול",
    2: "ראשון",
    3: "שבת",
  };

  const resolveIcon = () => {
    if (isFeatured && srcFeatured) return srcFeatured;
    switch (subCategory) {
      case "sudoku":
        return sudokuIcon;
      case "wordfinder":
        return wordfinderIcon;
      case "slide":
        return slideIcon;
      case "crossword":
        return crosswordIcon;
      default:
        return isFeatured && srcFeatured ? srcFeatured : src;
    }
  };

  const isFirst = isPuzzle && gameIndex === 0;

  const resolvePuzzleName = () => {
    const date2 = moment();
    const date1 = moment(new Date(name));
    const diff = date2.diff(date1, "days");

    switch (diff) {
      case 0:
        return "היום";
      case 1:
        return "אתמול";
      case 2:
      case 3:
      case 4:
        return moment(new Date(name)).format("dddd");
      default:
        return moment(new Date(name)).format("MMM Do");
    }
  };

  return (
    <TileLink to="#">
      <TileWrapper
        isFeatured={isFeatured}
        onClick={() => onGameClick(game)}
        isFirst={isFirst}
        gameIndex={gameIndex}
        isPuzzle={isPuzzle}
        isAside={isAside}
      >
        <TileImageWrapper
          isFeatured={isFeatured}
          full={!isPuzzle}
          isFirst={isFirst}
          isAside={isAside}
        >
          {isPuzzle && moment(new Date(name)).isSame(new Date(), "day") && (
            <div className="cr cr-top cr-right cr-blue">חדש</div>
          )}

          <TileImage
            full={!isPuzzle || isFeatured}
            isFeatured={isFeatured}
            src={resolveIcon()}
            alt="image-tile"
            isAside={isAside}
          />
          {!isPuzzle && (
            <TileIcon isFeatured={isFeatured} isAside={isAside}>
              <TileIconImg
                src={gameType === "game" ? gameIcon : quizIcon}
                isFeatured={isFeatured}
                isAside={isAside}
              />
            </TileIcon>
          )}
          {isPremium && (
            <PremiumIcon>
              <img
                width="60"
                height="auto"
                src="https://ynet-images1.yit.co.il/picserver5/wcm_upload/2022/03/09/ByNyECS115/ynet__logo_ynet_.png"
              />
            </PremiumIcon>
          )}
        </TileImageWrapper>
        <MetaWrapper>
          <MetaData>
            <TileDescription>
              {isPuzzle ? resolvePuzzleName() : name}
            </TileDescription>
            <TileMeta>
              {isPuzzle ? description : gameType === "game" ? "משחק" : "חידון"}
            </TileMeta>
          </MetaData>

          {!isPuzzle && (
            <TileCTA isFeatured={isFeatured} isQuiz={category === "quiz"}>
              {category === "quiz" ? "לחידון" : "למשחק"}
            </TileCTA>
          )}
        </MetaWrapper>
      </TileWrapper>
    </TileLink>
  );
}

export default Tile;
